import * as React from 'react'

import { Input } from '~ui/components/formElements/Input/Input'
import { IconEye, IconEyeOff } from '~ui/components/icons/specific/IconEye'

import { FORM_INPUT_RADIUS } from '../../config/form.config'

type TInputProps = Pick<
  PropsOf<typeof Input>,
  'value' | 'id' | 'onBlur' | 'onChange' | 'isInvalid' | 'isDisabled' | 'autoComplete'
>

type TInputType = Defined<PropsOf<typeof Input>['type']>
type TPasswordInputType = ExtractSafe<TInputType, 'text' | 'password'>

type TProps = NoChildren & TInputProps

/**
 * Generic password input with the right eye-icon that on click hides/shows input value (characters).
 */
export const PasswordInputElement: React.FC<TProps> = ({ ...inputProps }) => {
  const [type, setType] = React.useState<TPasswordInputType>(`password`)

  const toggleType = () => {
    setType((prevType) => {
      return prevType === `password` ? `text` : `password`
    })
  }

  return (
    <Input
      {...inputProps}
      type={type}
      radius={FORM_INPUT_RADIUS}
      rightIcon={{
        icon: type === `password` ? IconEye : IconEyeOff,
        contrast: `low`,
        onClick: toggleType,
      }}
    />
  )
}
